<template>
  <div>
    <div id="modalOpcoesPagamento" class="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
      <div class="modal-dialog modal-dialog-centered" style="margin-top: 30px" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title text-center"><strong>Formas de pagamento</strong></h2>
          </div>
          <div class="modal-body">
            <div class="modal-title text-center col-md-12 modal-header" style="padding: 0px">
              <div class="col-md-12" style="padding: 0px">
                <h4>
                  <strong> Boleto / Pix </strong>
                </h4>
              </div>
              <div class="row" style="color: #007bff">
                <h3>
                  {{ convertToReal(preco) }}
                </h3>
                <div class="row" style="color: black">Valor à vista com desconto</div>
              </div>
            </div>
            <div v-if="parcelasFidic.length > 0">
              <div class="row text-center">
                <div class="col-md-12" style="padding: 10px">
                  <div class="row">
                    <h4>
                      <strong> Destrave seu Negócio </strong>
                    </h4>
                    <h4>Parcelamento à Prazo</h4>
                    <img src="/assets/images/IconeDestrave.jpg" alt="Destrave seu negócio" style="max-width: 120px; height: auto" />
                    <h4 style="color: red;">Entrada 30%</h4>
                  </div>
                </div>
              </div>
              <hr width="450px" />
              <div class="row" style="padding: 10px">
                <div class="col-md-12">
                  <div id="parcelamentosDoProduto" class="tab-content-item-card">
                    <table class="table table-striped col-md-8" style="text-align: center">
                      <thead>
                        <tr class="table-head">
                          <th scope="col" class="col-md-6 text-center">Parcelas</th>
                          <th scope="col" class="col-md-6 text-center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(parcelamento, index) in parcelasFidic" :key="index">
                          <td v-if="index % 2 == 0" class="col-md-8" style="background-color: #e2f5fe; font-size: 14px">
                            {{ parcelamento.descricao }}
                          </td>
                          <td v-else="" class="col-md-8" style="font-size: 14px">
                            {{ parcelamento.descricao }}
                          </td>
                          <td v-if="index % 2 == 0" class="col-md-4" style="background-color: #e2f5fe; font-size: 14px">
                            {{ convertToReal(parcelamento.total) }}
                          </td>
                          <td v-else="" class="col-md-4" style="font-size: 14px">
                            {{ convertToReal(parcelamento.total) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row text-center modal-header"></div>
              <hr width="450px" />
            </div>
            <div class="row">
              <div class="col-md-12" style="padding: 20px">
                <div class="row text-center modal-header" style="padding-top: 10px">
                  <h4>
                    <strong> Cartões de crédito </strong>
                  </h4>
                  <h5>Em até 21x com juros*</h5>
                </div>
                <div scope="col-bandeiras" class="row text-center">
                  <div class="text-flag">
                    <h5>Selecione a bandeira:</h5>
                  </div>
                  <ul class="nav nav-tabs" role="tablist">
                    <li role="presentation" :class="{ active: bandeira == 1 }">
                      <a @click="bandeiraAtiva(1)"
                        ><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Visa.png" /></i
                      ></a>
                    </li>
                    <li role="presentation" :class="{ active: bandeira == 2 }">
                      <a @click="bandeiraAtiva(2)"
                        ><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Master.png" /></i
                      ></a>
                    </li>
                    <li role="presentation" :class="{ active: bandeira == 3 }">
                      <a @click="bandeiraAtiva(3)"
                        ><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Elo.png" /></i
                      ></a>
                    </li>
                    <!-- <li role="presentation" :class="{ active: bandeira == 4 }"><a @click="bandeiraAtiva(4)"><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Hipercard.png"/></i></a></li>
                                        <li role="presentation" :class="{ active: bandeira == 5 }"><a @click="bandeiraAtiva(5)"><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Amex.png"/></i></a></li> -->
                  </ul>
                </div>
                <div style="padding-top: 10px" class="row text-center">
                  <Loader v-if="loadingInstallments" />
                  <h5 style="padding-top: 10px" v-if="loadingInstallments">Carregando simulação das parcelas...</h5>
                </div>
                <div v-show="!loadingInstallments" id="parcelamentosDoProduto" class="tab-content-item-card">
                  <table class="table table-striped col-md-8" style="text-align: center">
                    <thead>
                      <tr class="table-head">
                        <th scope="col" class="col-md-6 text-center">Parcelas</th>
                        <th scope="col" class="col-md-6 text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(parcelamento, index) in productInstallments" :key="index">
                        <td v-if="index % 2 == 0" class="col-md-6" style="background-color: #e2f5fe; font-size: 14px">
                          {{ parcelamento.numeroDeParcelas }}x de
                          {{ convertToReal(parcelamento.parcelasDe) }}
                        </td>
                        <td v-else="" class="col-md-6" style="font-size: 14px">
                          {{ parcelamento.numeroDeParcelas }}x de
                          {{ convertToReal(parcelamento.parcelasDe) }}
                        </td>
                        <td v-if="index % 2 == 0" class="col-md-6" style="background-color: #e2f5fe; font-size: 14px">
                          {{ convertToReal(parcelamento.valorFinal) }}
                        </td>
                        <td v-else="" class="col-md-6" style="font-size: 14px">
                          {{ convertToReal(parcelamento.valorFinal) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-md-6" style="float: left; text-align: left; padding: 0px">
              <h6>* Haverá alteração no valor da parcela conforme a bandeira do cartão.</h6>
            </div>
            <div class="col-md-3" style="float: right; padding: 0px">
              <button v-on:click="closeModalOpcoesPagamento()" class="btn btn-primary btn-sm btn-block">FECHAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isCarousel" style="margin-top: -20px; margin-bottom: 20px">
      <a :href="url"> Para mais opções de pagamentos, verifique os detalhes do produto. </a>
    </div>
    <div
      @click="carregarDados"
      v-if="mostrarBotaoInterno"
      class="wrap-price small-price cartaocredito"
      data-toggle="modal"
      data-target="#modalOpcoesPagamento"
      style="cursor: pointer !important"
    >
      <span>Ver mais opções de pagamento</span>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { convertNumberToReal } from '../Utils/formatNumber'
export default {
  name: 'PaymentOptionsModal',
  props: {
    preco: Number,
    codigoProduto: Number,
    mostrarBotaoInterno: {
      type: Boolean,
      default: true
    },
    isCarousel: {
      type: Boolean,
      default: false
    },
    url: String
  },

  data() {
    return {
      productInstallments: [],
      loadingInstallments: true,
      bandeira: 1,
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      valorRepasseFormatado: '',
      parcelasFidic: [],
      loadingParcelasFidic: true
    }
  },
  methods: {
    convertToReal(number) {
      return convertNumberToReal(number)
    },
    openModalExternamente() {
      $('#modalOpcoesPagamento').modal('show')
    },
    bandeiraAtiva(numeroBandeira) {
      this.bandeira = numeroBandeira
      this.getValoresParcelamento(this.preco.replace('R$ ', '').replace('.', '').replace('.', '').replace(',', '.'), this.bandeira)
    },
    getValoresParcelamento(valorDoProduto, bandeira) {
      const self = this
      self.loadingInstallments = true

      if (typeof valorDoProduto === 'string') {
        valorDoProduto = parseFloat(valorDoProduto)
      }

      let session = JSON.parse(localStorage.getItem('usuarioLogado'))
      const codBandeira = parseInt(bandeira)
      const codigoPedido = session.CodigoPedido

      axios
        .post(
          self.$apiUrl + 'PagamentoCartao.svc/CreditCardProductInterestRates',
          {
            codigoPedido: codigoPedido,
            codigoProduto: self.codigoProduto,
            valorProduto: valorDoProduto,
            bandeira: codBandeira
          },
          { withCredentials: true }
        )
        .then((response) => {
          if (response.data) {
            self.productInstallments = response.data.map((item) => {
              const valorFinalCalculado = item.FinalValue
              return {
                numeroDeParcelas: item.InstallmentNumber,
                valorFinal: valorFinalCalculado,
                parcelasDe: valorFinalCalculado / item.InstallmentNumber
              }
            })
          }
          self.loadingInstallments = false
        })
        .catch((error) => {
          console.error('Erro ao buscar parcelamentos:', error)
          self.loadingInstallments = false
        })
    },

    getValoresParcelamentoFidic(valorDoProduto) {
      const self = this

      const xhr = new XMLHttpRequest()
      xhr.open('get', this.$apiUrl + 'Produto.svc/getPrecoAprazo/' + valorDoProduto)
      xhr.withCredentials = true

      xhr.onprogress = function () {
        self.loadingParcelasFidic = true
      }

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status !== 200) {
          self.installmentsError = true
        }
      }

      xhr.onload = function () {
        try {
          const data = JSON.parse(xhr.responseText)

          if (Array.isArray(data)) {
            self.parcelasFidic = data.map((f) => ({
              descricao: f.DescricaoParaInternet,
              total: f.ValorParcela
            }))
          }
        } catch (e) {
          self.installmentsError = true
        }
        self.loadingParcelasFidic = false
      }

      xhr.send()
    },

    closeModalOpcoesPagamento: function () {
      $('#modalOpcoesPagamento').modal('hide')
    },

    formatCurrency: function (v) {
      //formada coluna de valores da tabela para moeda
      const formato = {
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL'
      }

      return parseFloat(v).toLocaleString('pt-BR', formato)
    },
    carregarDados() {
      this.getValoresParcelamento(this.preco, this.bandeira)
      this.getValoresParcelamentoFidic(this.preco)
    }
  }
  // mounted() {
  //   this.getValoresParcelamento(this.preco.replace('R$ ', '').replace('.', '').replace('.', '').replace(',', '.'), this.bandeira)
  //   this.getValoresParcelamentoFidic(this.preco.replace('R$ ', '').replace('.', '').replace('.', '').replace(',', '.'))
  // }
}
</script>
